/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box } from "@mui/material";
import LegalbirdLoader from "@/src/components/ContentLoader/LegalbirdLoader";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";
import React from "react";

export default function MessageFormLoader() {
  return (
    <ContentBox>
      <Box sx={{ padding: "1rem" }}>
        <LegalbirdLoader />
      </Box>
    </ContentBox>
  );
}
